import DataGrid from "../../genericGrid";
import AppCard from "../../genericComponents/AppCard";
const DataGridCard = ({ icon, title, type, onClick, ...props }) => {
    return <AppCard icon={icon} title={title}>
        <DataGrid
            {...props}
            onClick={onClick}
            type={type} />
    </AppCard>
}
export default DataGridCard;